import React from 'react'
import { useInternationalization } from '../features/i18n'
import { FileUploader } from './file-uploader'

const FileUploaderWithPreview = ({
  inputTrigger,
  defaultFile,
  onChange,
  single
}) => {
  const [defaultFileLocal, setDefaultFileLocal] = React.useState(undefined)
  const [showInput, setShowInput] = React.useState(true)
  const [files, setFiles] = React.useState([])
  const { translate } = useInternationalization()

  React.useEffect(() => {
    if(defaultFile){
      setDefaultFileLocal(defaultFile)
      setShowInput(false)
    }
  }, [defaultFile])

  React.useEffect(() => {
    if(typeof onChange === 'function'){
      onChange(files)
    }

    if(single && files.length > 0){
      setShowInput(false)
    }
    //eslint-disable-next-line
  }, [files])

  const handleChange = (e) => {
    const cloned = JSON.parse(JSON.stringify(files))
    if(e.target.files[0]){
      const name = e.target.files[0].name
      const type = e.target.files[0].type
      const blob = URL.createObjectURL(e.target.files[0])

      const obj = {
        name,
        file: blob,
        type,
      }

      cloned.push(obj)
      setFiles(cloned)
    }
  }

  const handleDelete = (selectedIndex) => {
    let result = []
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      if(index !== selectedIndex){
        result.push(file)
      }
    }
    setFiles(result)

    console.log(result, single && result.length === 0)

    if(single && result.length=== 0){
      setShowInput(true)
    }
  }

  const defaultFileName = () => {
    let result = ''
    if(typeof defaultFileLocal === 'string'){
      const splitted = defaultFileLocal.split('/')
      result = splitted[splitted.length-1]
    }
    return result
  }

  const removeDefaultFile = () => {
    setDefaultFileLocal(undefined)
    setShowInput(true)
  }

  return (
    <div>
      {
        defaultFileLocal &&
        <div className="flex items-center justify-between mb-8">
          <p className="font-bold text-primary underline mr-4 text-sm">{defaultFileName()}</p>
          <p className="text-xs text-gray-999 underline cursor-pointer" onClick={removeDefaultFile}>
            {translate('GENERAL', 'delete')}
          </p>
        </div>
      }
      {
        files.map((f, i) => (
          <div className="flex items-center justify-between mb-8" key={i}>
            <p className="font-bold text-primary underline mr-4 text-sm">{f.name}</p>
            <p className="text-xs text-gray-999 underline cursor-pointer" onClick={() => handleDelete(i)}>
              {translate('GENERAL', 'delete')}
            </p>
          </div>
        ))
      }
      {
        showInput && (
          <FileUploader inputTrigger={inputTrigger} onChange={handleChange} />
        )
      }
    </div>
  )
}

export { FileUploaderWithPreview }
